import { Loader } from "@mantine/core";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/login/callback/")({
  component: RouteComponent,
  beforeLoad: async ({ context }) => {
    await context.queryClient.invalidateQueries();
    throw redirect({ to: "/" });
  },
});

function RouteComponent() {
  return (
    <div className="flex h-screen items-center justify-center">
      <Loader size="xl" />
    </div>
  );
}
